import { createStore } from "vuex";

export default createStore({
  state: {
    client: null,
    theme: "auto",
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
